import Head from 'next/head';
import Link from 'next/link';

import { DGBuySellHelpSEO } from '@/utils/constants/MetaData';

const General = () => {
  return (
    <>
      <Head>
        <title>{DGBuySellHelpSEO.metaTitle}</title>
        <meta name="description" content={DGBuySellHelpSEO.metaDescription} />
        <meta
          property="og:description"
          content={DGBuySellHelpSEO.metaOGDescription}
        />
        <link
          rel="canonical"
          href="https://muthootfincorpone.com/help/digital-gold/buy-sell/"
        />
      </Head>
      <main className="repayment singleFlow--lightBlue pledge setting">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <Link href="/help">eSwarna Digital Gold Help</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Buy / Sell
              </li>
            </ol>
          </nav>
          <div className="loanDetails__card loanCard accordion setting-faq-accordion">
            <h1 className="loanCard__title text--bold text--black">
              Buy / Sell
            </h1>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingOne"
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="false"
                aria-controls="collapseOne"
              >
                <h2 className="text--black text--semi title">
                  How much gold can I buy?
                </h2>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can buy gold up to Rs. 1,90,000 (one lakh ninety
                    thousand only) in tranches or in aggregate without KYC in a
                    financial year. With KYC compliance, there is no upper cap
                    on buying gold.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTwo"
                data-toggle="collapse"
                data-target="#collapseTwo"
                aria-expanded="false"
                aria-controls="collapseTwo"
              >
                <p className="text--black text--semi title">
                  What is the minimum and maximum amount needed to buy gold on
                  Muthoot FinCorp ONE?
                </p>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The minimum amount of purchase is Re.1. There is no limit on
                    the maximum amount subject to KYC criteria. In case of SIP,
                    a customer can invest a minimum amount of Rs. 10 and a
                    maximum amount of Rs. 5,000 on a single SIP.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingThree"
                data-toggle="collapse"
                data-target="#collapseThree"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <p className="text--black text--semi title">
                  How can I get my transaction receipt?
                </p>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    An online receipt for every Buy/Sell transaction can be
                    downloaded from the order details page. The customer will
                    also receive a SMS and email notification with a link to
                    download the receipt after each successful transaction.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFour"
                data-toggle="collapse"
                data-target="#collapseFour"
                aria-expanded="false"
                aria-controls="collapseFour"
              >
                <p className="text--black text--semi title">
                  At what price is gold sold/ bought from customers?
                </p>
              </div>
              <div
                id="collapseFour"
                className="collapse"
                aria-labelledby="headingFour"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    All Buy/Sell transactions on Muthoot FinCorp ONE are based
                    on the live gold rate reflected on the app. This price is
                    locked for 4 mins and 30 secs for the customer to complete
                    the transaction. In case the transaction is not completed
                    within the given time the system is refreshed with the live
                    gold rate.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingFive"
                data-toggle="collapse"
                data-target="#collapseFive"
                aria-expanded="false"
                aria-controls="collapseFive"
              >
                <p className="text--black text--semi title">
                  Is my gold insured and safe?
                </p>
              </div>
              <div
                id="collapseFive"
                className="collapse"
                aria-labelledby="headingFive"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Yes, your gold is safe through Muthoot Exim’s comprehensive
                    insurance policy and secured in vaults by Muthoot EXIM
                    appointed custodian Sequel Logistics completely free of
                    cost.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSix"
                data-toggle="collapse"
                data-target="#collapseSix"
                aria-expanded="false"
                aria-controls="collapseSix"
              >
                <p className="text--black text--semi title">
                  What is the lock-in period to sell my eSwarna digital gold
                  after purchase?
                </p>
              </div>
              <div
                id="collapseSix"
                className="collapse"
                aria-labelledby="headingSix"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    You can sell your gold after 1 working day of the purchase
                    transaction.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingSeven"
                data-toggle="collapse"
                data-target="#collapseSeven"
                aria-expanded="false"
                aria-controls="collapseSeven"
              >
                <p className="text--black text--semi title">
                  Can someone else redeem my Digital/physical gold on my behalf?
                </p>
              </div>
              <div
                id="collapseSeven"
                className="collapse"
                aria-labelledby="headingSeven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Only in the event of a customer’s death, their legal heir
                    will be able to collect the gold coin, jewellery or encash
                    it via Sell transaction. This can be done only after
                    submitting their proof of identity along with the original /
                    notarized copy of the customer’s death certificate and proof
                    that the person is the legal heir of the account holder.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEight"
                data-toggle="collapse"
                data-target="#collapseEight"
                aria-expanded="false"
                aria-controls="collapseEight"
              >
                <p className="text--black text--semi title">
                  When I sell my Gold, how soon will I get the funds credited to
                  my account?
                </p>
              </div>
              <div
                id="collapseEight"
                className="collapse"
                aria-labelledby="headingEight"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    Once the Ssale transaction is successful on Muthoot FinCorp
                    ONE platform, the funds will be instantly credited to the
                    customer&apos;s bank account. However, if there is any
                    technical glitch or any operational challenge at the
                    bank&apos;s end, Muthoot FinCorp ONE will credit the
                    customer&apos;s bank account within 03 working days.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingNine"
                data-toggle="collapse"
                data-target="#collapseNine"
                aria-expanded="false"
                aria-controls="collapseNine"
              >
                <p className="text--black text--semi title">
                  Is it mandatory to do KYC while selling of gold?
                </p>
              </div>
              <div
                id="collapseNine"
                className="collapse"
                aria-labelledby="headingNine"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    For any sale transaction, KYC is mandatory.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingTen"
                data-toggle="collapse"
                data-target="#collapseTen"
                aria-expanded="false"
                aria-controls="collapseTen"
              >
                <p className="text--black text--semi title">
                  Is it mandatory to do KYC for Buy transaction?
                </p>
              </div>
              <div
                id="collapseTen"
                className="collapse"
                aria-labelledby="headingTen"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The customer must complete the KYC for the following Buy
                    transactions:
                    <br />
                    1. Whenever the overall eSwarna Digital Gold holdings on
                    Muthoot FinCorp ONE exceed INR 1,90,000.
                    <br /> 2. Whenever the cumulative SIP amount exceeds INR
                    20,000.
                  </p>
                </div>
              </div>
            </div>
            <div className="setting-faq-card">
              <div
                className="header"
                id="headingEleven"
                data-toggle="collapse"
                data-target="#collapseEleven"
                aria-expanded="false"
                aria-controls="collapseEleven"
              >
                <p className="text--black text--semi title">
                  What are the required KYC documents?
                </p>
              </div>
              <div
                id="collapseEleven"
                className="collapse"
                aria-labelledby="headingEleven"
                data-parent="#accordion"
              >
                <div className="accordion__details">
                  <p className="text--semi text--gray answer">
                    The following documents are mandatory for KYC:
                    <br />
                    1. PAN card
                    <br /> 2. Aadhaar card
                    <br /> 3. Liveliness check
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default General;
